export const LOG_APP_INFO_CONSOLE_CONTEXT =
  "__showpass_log_app_info_console_context";

type LogAppInfoConsoleContext = {
  [LOG_APP_INFO_CONSOLE_CONTEXT]: true;
  level: "info" | "warning" | "error";
  category?: string;
  data?: Record<string, unknown>;
};

export function markLogAppInfoConsoleContext({
  category,
  data,
  level,
}: {
  category?: string;
  data?: Record<string, unknown>;
  level: "info" | "warning" | "error";
}): LogAppInfoConsoleContext {
  return {
    [LOG_APP_INFO_CONSOLE_CONTEXT]: true,
    category,
    data,
    level,
  };
}

export function isLogAppInfoConsoleContext(
  value: unknown
): value is LogAppInfoConsoleContext {
  if (typeof value !== "object" || value === null) return false;

  return (
    (value as Record<string, unknown>)[LOG_APP_INFO_CONSOLE_CONTEXT] === true
  );
}
